import { render, staticRenderFns } from "./newArticles.vue?vue&type=template&id=781b960e&scoped=true&"
import script from "./newArticles.vue?vue&type=script&lang=js&"
export * from "./newArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781b960e",
  null
  
)

export default component.exports